module.exports = {
  "country": "SI",
  "artist": "Nusa Derenda",
  "song": "Energy",
  "year": "2001",
  "place": "7",
  "spotify": ""
};